import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { FlussoRowComponent } from "./flusso-row/flusso-row.component";
import { Flusso } from "../../../@core/data/flusso";
import { FlussoService } from "../../../@core/api/flusso.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-flussi-table",
  templateUrl: "./flusso-table.component.html",
  styleUrls: ["./flusso-table.component.scss"],
})
export class FlussiTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  flussi: Flusso[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private flussoService: FlussoService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getFlussi();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getFlussi();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getFlussi();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getFlussi() {
    this.loading = true;
    this.flussi = <Flusso[]>(
      await this.flussoService.getFlussi(
        this.pagination,
        this.filters,
        this.order
      )
    );

    this.flussi.map((f) => {
      f.notAllowed = Object.keys(f.notAllowed).map((k) => {
        return {
          id: k,
          values: f.notAllowed[k].values,
          title: f.notAllowed[k].title,
        };
      });
    });

    console.log(this.flussi)

    this.loading = false;

    if (this.flussi.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  async createFlusso() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home", "flusso"]);
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getFlussi();
  }
}
